module.exports = __webpack_public_path__ + "img/logo-am.bfdf7cad.png";